import { css } from 'react-emotion'

const styles = {
  component: css({
    cursor: 'pointer',
    marginRight: '12px',
    '& :hover': css({
      transform: 'scale(1.2)'
    })
  }),
  button: css({
    padding: '8px 10px',
    color: '#919191',
    whiteSpace: 'nowrap'
  }),
  loader: css({
    display: 'flex',
    alignItems: 'center',
    marginRight: '12px',
  })
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CaptureVideoImage/CaptureVideoImageStyles.js